import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  enabled?: boolean
  filter: {
    clientIds?: Array<number>
    cameraIds?: Array<number>
    companyIds?: Array<number>
  }
  start: string
  end: string
}

export default function useDashboardCountingObjects({enabled, filter, start, end}: Props) {
  const query = useQuery({
    enabled,
    refetchOnWindowFocus: false,
    queryKey: [QueryKeyEnum.DASHBOARD_COUNTING_OBJECTS_SERIES, filter, enabled, start, end],
    queryFn: async () => (await api.reports.getCountingObjectBySeries({filter, start, end})).data,
  })

  return query
}
